import { defaultConfig, plugin as FormkitPlugin } from '@formkit/vue'
import formkitConfig from '@root/formkit.config.js'

export default function (app) {
  app.use(FormkitPlugin, defaultConfig(formkitConfig))
}
